<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div class="clearfix border rounded mt-3 mr-3 mb-3 col-md-12">
              <div class="row justify-content-center border-bottom "><div class="col-sm-12 mt-1 mb-1">GF Contribution History for {{company_name}}</div></div>
              <div class="row mt-2 mb-2">
              <div class="col-md-2 text-right float-right">
              <div class="border rounded text-center">
               <div class="border-bottom pt-2 pb-2">{{c_date}}</div>
               <div>{{c_time}}</div>
              </div>
              </div>
              </div>
               <div  class="clearfix row no-gutters" v-if="employee_id>0">            
            <loan-public-info :pageurl="this.$api_url"  :employee_id="employee_id" :key="c_flg"></loan-public-info>
        </div>
        <div class="row  py-3">
            <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span> 
                <div class="dash-widget-info">
                <h3>{{formatMoney(company_gf_history.company_ff_fund - company_gf_history.company_ff_distributed_amount - company_gf_history.total_distributed_reclaim)}}</h3>
                <span>Available Forfeature Fund</span>
                </div>
                </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{formatMoney(company_gf_history.company_ff_distributed_amount)}}</h3>
                <span>Total Distributed Forfeature</span>
                </div>
                </div>
                </div>
            </div>

            <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{formatMoney(company_gf_history.total_distributed_reclaim)}}</h3>
                <span>Total Distributed Forfeature Recalaim</span>
                </div>
                </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{formatMoney(company_gf_history.total_distributed_profit)}}</h3>
                <span>Total Distributed Profit</span>
                </div>
                </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{formatMoney(company_gf_history.total_distributed_loan)}}</h3>
                <span>Total Distributed Loan</span>
                </div>
                </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{formatMoney(company_gf_history.total_refunded_loan)}}</h3>
                <span>Total Refunded Loan</span>
                </div>
                </div>
                </div>
            </div>
        </div>
        </div>
        <div class="card">
            <div class="card-header ">
                <div class="card-header-inner clearfix mt-3">
                    <div class="float-left align-self-center pt-1 col-sm-4 px-0" style="font-size: 18px;">Total employees <span class="ml-2" style="color: #5A8DEE;">{{people}}</span></div>
                    <div class="float-left align-self-center col-sm-8 custom-search pr-0">
                        <b-input-group >
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search by employee / position / branch / email / phone" v-model="search" @input="setSearch()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
            </div>
            <div class="card-body container px-0">
             <table class="table table-borderless table-striped table-hover table-sm border-dark-custom employee-list-table employee-list-table-alt"> 
                                    <thead>
                                        <tr class="table-head" style="background: rgba(128,128,128,0.2);">
                                            <td class="align-top border-dark-custom"><input type="checkbox" v-model="selectAll" class="justify-content-center"/>&nbsp;<label class="mb-0 custom-label">Name</label></td>                        
                                            <td class="align-top border-dark-custom">GF Entitlement Date</td>
                                            <td class="align-top border-dark-custom">Total Contribution</td>
                                            <td class="align-top border-dark-custom">&nbsp;</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <template v-if="gf_data">
                                        <tr v-for="employee_gf in gf_data" :key="employee_gf.employee_id">
                                            <td>
                                                <input type="checkbox" class="justify-content-center" v-model="selected" :value="employee_gf.employee_id" number />
                                                <label class="mb-0 custom-label">
                                                    <span class="employee-img">
                                                        <img v-if="employee_gf.pic != ''" v-bind:src="$api_url+'/public/images/employee/'+ employee_gf.company_id + '/' + employee_gf.pic" class="img-fluid img-thumbnail employee-avatar mx-2" />
                                                        <img v-else v-bind:src="$api_url+'/public/images/employee/demo.jpg'" class="img-fluid img-thumbnail employee-avatar mx-2" />
                                                    </span>
                                                    <span class="cursor-pointer employee-name">{{employee_gf.name}}<br />{{employee_gf.jobposition}},{{employee_gf.department}}</span>
                                                </label>
                                            </td>
                                            <td>{{employee_gf.gf_start}}</td>
                                            <td>{{formatMoney(employee_gf.gf_total)}}</td>
                                            <td><b-button variant="secondary" @click="gfDetailsNew(employee_gf)">Details</b-button></td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                    
                                    <tr v-for="employee_gf in gf_data" :key="employee_gf.employee_id">
                                            <td class="align-middle border-dark-custom text-secondary py-3" :colspan=7></td>
                                    </tr>
                                    </template>
                                    </tbody>
                                </table>           
                <div class="clearfix row p-2 float-right no-margin" v-if="gf_data.length > 0">
                    <div class="clearfix row p-2 float-right no-margin" v-if="gf_data.length > 0">                
                        <ul class="pagination b-pagination">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="length" :options="length_options" @change="setSearch()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right" v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" @input="setPage()"  first-number last-number ></b-pagination-nav>
                    </div>
                </div>
                
                <!--<div class="row  clearfix w-100" v-if="gf_data.length>0"> -->
                    <div class="row  clearfix w-100" v-if="0"> 
       			       <div class="col-md-12">
                          <b-overlay :show="action_loader" rounded="sm">
                              <div class="col-md-12 "><b-button class="border rounded bg-light py-1 px-2 mt-2 ml-0" type="button" variant="primary" @click="downloadFullGFReport('excel','true')"><i class="fas fa-file-download mr-1" aria-hidden="true" style="font-size:18px;color:#56a4cd;"></i>Download Report for Selected Employees in Excel</b-button> <b-button class="border rounded bg-light py-1 px-2 mt-2 ml-2" type="button" variant="primary" @click="downloadFullGFReport('excel')"><i class="fas fa-file-download mr-1" aria-hidden="true" style="font-size:18px;color:#56a4cd"></i>Download Full Report in Excel</b-button></div>
                          </b-overlay>
                       </div>
                 </div>
                 
                 <!--<div class="row clearfix w-100" v-if="gf_data.length>0">-->
                     <div class="row clearfix w-100" v-if="0">
       			       <div class="col-md-12"> 
                          <b-overlay :show="action_loader2" rounded="sm">
                              <div class="col-md-12"><b-button class="border rounded bg-light py-1 px-2 mt-2 ml-0" type="button" variant="primary" @click="downloadFullGFReport('pdf','true')"><i class="fas fa-file-download mr-1" aria-hidden="true" style="font-size:18px;color:#56a4cd;"></i>Download Report for Selected Employees in PDF</b-button> <b-button class="border rounded bg-light py-1 px-2 mt-2 ml-3" type="button" variant="primary" @click="downloadFullGFReport('pdf')"><i class="fas fa-file-download mr-1" aria-hidden="true" style="font-size:18px;color:#56a4cd"></i>Download Full Report in PDF</b-button></div>
                          </b-overlay>
                       </div>
                     </div> 
                 </div>
                
            </div>
            
            <b-modal id="bv-modal-gf-details" hide-footer  title="" size="lg">
            <b-overlay :show="gfoverlay" rounded="sm">
            
            <div class="row justify-content-center"><div class="col-sm-12 mt-1 mb-1 text-center">{{emp_gf_title}}<span v-if="empdata.etin !=''"> (eTIN-{{empdata.etin}}) - {{company_name}}</span></div></div>
            <div class="clearfix border rounded mt-3 mr-3 mb-0 col-md-12">
                <div class="row justify-content-center"><div class="col-sm-12 mt-1 mb-1 text-center">Current Gratuity Fund Balance : {{formatMoney(this.curr_emp_gf_total)}}</div></div>
            </div>
            <div class="clearfix border rounded mt-3 mr-3 mb-0 col-md-12">
                
                        
            		    <table class="table table-bordered mt-3"> 
            		       <tbody>
     		                <tr class="s-thead"><th>Month - Year</th><th>Employer's Contribution</th><th>Employees Contribution</th><th>Profit Contribution</th><th>Forfieture Contribution</th><th>(-) Loan Availed</th><th>Loan Refunded</th><th>(-) Settlement</th><th>Total</th></tr>
                            <template v-for="m_data_row  in m_search_data">
                             <tr><td>{{m_data_row.month}} - {{m_data_row.year}}</td><td>{{formatMoney(m_data_row.gf_employer)}}</td><td>{{formatMoney(m_data_row.gf_employee)}}</td><td>{{formatMoney(m_data_row.gf_profit)}}</td><td>{{formatMoney(m_data_row.gf_forfieture)}}</td><td>({{formatMoney(m_data_row.gf_loan_availed)}})</td><td>{{formatMoney(m_data_row.gf_loan_refund)}}</td><td>({{formatMoney(m_data_row.gf_settlement)}})</td><td>{{formatMoney(m_data_row.monthly_total)}}</td></tr>   
                            </template> 
                             <template>
                                 <tr class="s-thead"><th>Migrated GF Total</th><th>{{formatMoney(curr_emp_mgf_total.gf_employer)}}</th><th>{{formatMoney(curr_emp_mgf_total.gf_employee)}}</th><th>--</th><th>--</th><th>--</th><th>--</th><th>--</th><th>{{formatMoney(curr_emp_mgf_total.gf_employer+curr_emp_mgf_total.gf_employee)}}</th></tr>
                                 <tr class="s-thead"><th>Total</th><th>{{formatMoney(curr_emp_monthly_gf_total.gf_employer)}}</th><th>{{formatMoney(curr_emp_monthly_gf_total.gf_employee)}}</th><th>{{formatMoney(curr_emp_monthly_gf_total.gf_profit)}}</th><th>{{formatMoney(curr_emp_monthly_gf_total.gf_forfieture)}}</th><th>({{formatMoney(curr_emp_monthly_gf_total.gf_loan_availed)}})</th><th>{{formatMoney(curr_emp_monthly_gf_total.gf_loan_refund)}}</th><th>({{formatMoney(curr_emp_monthly_gf_total.gf_settlement)}})</th><th>{{formatMoney(curr_emp_monthly_gf_total.gf_loan_refund +curr_emp_monthly_gf_total.gf_employer+curr_emp_monthly_gf_total.gf_employee  + curr_emp_monthly_gf_total.gf_profit + curr_emp_monthly_gf_total.gf_forfieture - curr_emp_monthly_gf_total.gf_loan_availed - curr_emp_monthly_gf_total.gf_settlement )}}</th></tr>
                             </template>
            		       </tbody>
            		      </table>
    		  </div>
              
              <div class="row mt-0" v-if="m_search_data.length>0">
       			       <div class="col-md-12">
                          <b-overlay :show="action_loader" rounded="sm">
                              <div class="col-md-6 float-left text-left"><b-button class="border rounded bg-light py-1 px-2 mt-4 ml-2" type="button" variant="primary" @click="downloadGFReport('pdf',empdata.employee_id)"><i class="fas fa-file-download mr-1" aria-hidden="true" style="font-size:18px;color:#56a4cd;"></i>Download {{emp_btn_title}} in PDF</b-button></div>
                              <div class="col-md-6 float-right text-right"><b-button class="border rounded bg-light py-1 px-2 mt-4" type="button" variant="primary" @click="downloadGFReport('excel',empdata.employee_id)"><i class="fas fa-file-download mr-1" aria-hidden="true" style="font-size:18px;color:#56a4cd"></i>Download {{emp_btn_title}} in Excel</b-button></div>
                          </b-overlay>
                       </div>
              </div>
              
              <div class="row m-0 p-0 justify-content-center" v-if="m_search_data.length>0">
       			       <div class="col-md-12 text-center m-0 p-0">
                          <b-overlay :show="action_loader" rounded="sm">
                              <b-button class="border rounded bg-light py-1 px-2 mt-2 ml-2" type="button" variant="primary" @click="downloadGFReport('pdf',empdata.employee_id,'true')"><i class="fas fa-file-download mr-1" aria-hidden="true" style="font-size:18px;color:#56a4cd;"></i> Email {{emp_btn_title}}</b-button>
                              
                          </b-overlay>
                       </div>
              </div>
              
              </b-overlay>
            </b-modal>
            
            
            
        </div>
    </b-overlay>
</template>
<style scoped>
button.disabled{cursor: default;}
</style>

<script>
    export default{
        props: ['pageurl'],        
        
        data(){
            return {
                
                company_name: '',
                m_lists : [{value: '1', text: 'January'},{value: '2', text: 'February'},{value: '3', text: 'March'},{value: '4', text: 'April'},{value: '5', text: 'May'},{value: '6', text: 'June'},{value: '7', text: 'July'},{value: '8', text: 'August'},{value: '9', text: 'September'},{value: '10', text: 'October'},{value: '11', text: 'November'},{value: '12', text: 'December'}],
                y_lists: [parseInt(new Date().getFullYear())-4,parseInt(new Date().getFullYear())-3,parseInt(new Date().getFullYear())-2,parseInt(new Date().getFullYear())-1,parseInt(new Date().getFullYear())],
                c_date: '',
                c_time: '',
                month_from: parseInt(new Date().getMonth())+2 > 12 ? 1 : parseInt(new Date().getMonth())+2,
                year_from: parseInt(new Date().getFullYear())-1,
                year_to: parseInt(new Date().getFullYear()),
                month_to: parseInt(new Date().getMonth())+1,
                cu:window.location.href,
                ce:false,
                gf_data : [],    
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                selected: [],
                showoverlay : true,
                gfoverlay: true,
                empdata: [],
                m_search_data: [],
                emp_gf_title: '',
                emp_btn_title: '',

                notice: "",
                blankmsg : 'Fetching data..',
                people:0,
                
                gf_type: 0,
                curr_emp_gf_total:0,
                curr_emp_monthly_gf_total:{},
                mgf_data:[],
                curr_emp_mgf_total:{},
                gf_types: [
                    { value: "0", text: "Registered" },
                    { value: "1", text: "Unregistered" }
                ],
                

                fdata: {
                        },
                pgurl:this.$api_url,
                action_loader: false,
                action_loader2: false,
                search:'',
                length: 10,
                length_options: [{ value: 10, text: "10" },{ value: 20, text: "20" },{ value: 30, text: "30" },{ value: 40, text: "40" },{ value: 50, text: "50" }],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                company_gf_history:[],
            }
        },
        methods:{            

            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;                    
                }.bind(this));
            },
            resetFlter: function()
            { 
                this.getGFContributionsData();
            },
            paginate(total, length, pageNumber) 
            {
                let l = parseInt(total);
                let m = parseInt(length);
                this.pagination.from = total ? ((pageNumber - 1) * length) + 1 : ' ';
                this.pagination.to = pageNumber * length > total ? total : pageNumber * length;
                this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
                this.pagination.nextPage = total > this.pagination.to ? pageNumber + 1 : '';

                if(l > 0)
                {
                    this.pagination.pages = Math.ceil(l / m);
                }
                this.people = l;
                return array.slice((pageNumber - 1) * length, pageNumber * length);
            },
            resetPagination()
            {
                this.pagination.currentPage = 1;
                this.pagination.prevPage = '';
                this.pagination.nextPage = '';
            },
            setSearch: function(pageflg)
            {
                this.pagination.currentPage = 1;
                this.getGFContributionsData();
            },
            setPagination: function(pageflg)
            {                
                
                if(pageflg)
                    this.pagination.currentPage = this.pagination.nextPage;
                else    
                    this.pagination.currentPage = this.pagination.prevPage;
                
                this.getGFContributionsData();
            },
            
            setPage: function(pageflg)
            {                
                //if(pageflg)
                //this.pagination.currentPage = pageflg;
                this.getGFContributionsData();
                
            },
            getGFReportHeaderInfo: function(){
              axios.get(this.$api_url+'/gfreport/header')
              .then(function (response) {
                 this.company_name = response.data.company_name;
                 this.c_date = response.data.curr_date;
                 this.c_time = response.data.curr_time;
                 this.gf_type = response.data.gf_type;
                 
                 
              }.bind(this));
         
            },
            
            getGFContributionsData: function(){
            let currentObj = this;
            this.showoverlay = true;
              axios.get(this.$api_url+'/gfreport/contributions', {
                    params: {
                        year_from: this.year_from,
                        year_to: this.year_to,
                        month_from: this.month_from,
                        month_to: this.month_to,
                        per_page: this.length,
                        s_page: this.pagination.currentPage,
                        s_key: this.search,
                        gf_type: this.gf_type
                    }
                    })
              .then(function (response) {
                 this.showoverlay = false;
                 if(response.data.data)

                 if(response.data.data.gf_data.length >0)
                 { 
                     this.gf_data = response.data.data.gf_data;
                    this.people = response.data.data.total;
                    this.length = response.data.data.per_page;

                 }
                 else
                 {
                     this.gf_data = [];
                    this.people = 0;
                    this.length = 0;

                 }
                 
                 console.log(this.gf_data);
                 //this.pagination.currentPage = response.data.data.current_page;
                 
                 this.paginate(response.data.data.total, this.length, this.pagination.currentPage)
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
         
            },
             getCompanyGFData: function(){
            let currentObj = this;
            this.showoverlay = true;
              axios.get(this.$api_url+'/get_company_gf_data', {
                    params: {
    
                    }
                    })
              .then(function (response) {
                 console.log(response.data);
                 this.company_gf_history = response.data;
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
         
            },
            
            
            downloadGFReport: function(file_type,emp_id,email_file=false)
			  {
				     this.action_loader = true; 
                     var send_file = email_file ? 1: 0;
                     axios.get(this.$api_url+'/downloadgfreport' , {
							  params: {
							      serach_type: 0,
                                  gf_type: this.gf_type,
								  year_from: this.year_from,
								  year_to: this.year_to,
                                  month_from: this.month_from,
                                  month_to: this.month_to,
                                  y_year_from: this.y_year_from,
                                  y_year_to: this.y_year_to,
                                  d_type: file_type,
                                  employee_id: emp_id,
                                  em_file:  send_file
							  }
					  }).then(function(response){
					   
                      this.action_loader = false;
					  if(response.data.file_name){
				      if(email_file){
				        if(response.data.mail_success){
                        this.$bvToast.toast(response.data.mail_success, {
                                           title: 'Success',
                                            variant: 'success',
                                            solid: true
                        });
                        }else{
                            this.$bvToast.toast('Unable to sent report!!', {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                        }
				      }else{
    				      if(file_type=='pdf')
                          this.download_file(response.data.file_name,'GF Report for '+this.empdata.name+'.pdf');
                          else
                          this.download_file(response.data.file_name,'GF Report for '+this.empdata.name+'.xls');
                      }
                      }
                      else if(response.data.error){
                        this.$bvToast.toast(response.data.error, {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                      }else{
                        this.$bvToast.toast('Unexpected server error!', {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                      } 
				  }.bind(this));
	        }, 
            
            gfDetailsNew: function(employee_gf)
            {
            
            this.curr_emp_gf_total=0;
            this.curr_emp_monthly_gf_total=[];
            this.$bvModal.show('bv-modal-gf-details');
            this.gfoverlay = true;
            let currentObj = this;
             axios.get(this.$api_url+'/gfdetails/header', {
							  params: {
                                  employee_id: employee_gf.employee_id
							  }
             }).then(function(response){
		       if(response.data.data){
                 this.empdata = response.data.data;
                 
                 this.emp_gf_title = this.gf_types[this.gf_type].text + ' GF Contribution of '+this.empdata['name'];
                 this.emp_btn_title = this.empdata['name']+'\'s '+this.gf_types[this.gf_type].text + ' GF Report';
             
	           }
             }.bind(this)).catch(function (error){currentObj.serverError(error);});
            
            axios.get(this.$api_url+'/employee-gfcontribution-breakdown', {
							  params: {
                                  gf_start: employee_gf.gf_start,
                                  employee_id: employee_gf.employee_id
							  }
					  }).then(function(response){
                        this.curr_emp_monthly_gf_total.gf_employer = 0;
                        this.curr_emp_monthly_gf_total.gf_employee = 0;
                        this.curr_emp_monthly_gf_total.gf_profit = 0;
                        this.curr_emp_monthly_gf_total.gf_forfieture = 0;
                        this.curr_emp_monthly_gf_total.gf_loan_availed = 0;
                        this.curr_emp_monthly_gf_total.gf_loan_refund = 0;
                        this.curr_emp_monthly_gf_total.gf_settlement = 0;
					   this.gfoverlay = false;
				       if(response.data.data){
                         this.curr_emp_gf_total = employee_gf.gf_total;
                         this.m_search_data = response.data.data;
                         this.mgf_data = response.data.migrated_gf;
                         this.getMigratedGfTotalContribution(this.mgf_data);
                         this.getGfMonthlyTotalContribution(this.m_search_data);
                         
                         
			           }
                      }.bind(this)).catch(function (error){currentObj.gfoverlay = false; currentObj.serverError(error);});

           },
           
            getGfMonthlyTotalContribution: function(gf_cont_data)
            {
                
                if(gf_cont_data.length>0)
                {

                    let gf_employer_total = 0.00;
                    let gf_employee_total = 0.00;
                    let gf_profit_total = 0.00;
                    let gf_forfieture_total = 0.00;
                    let gf_loan_availed_total = 0.00;
                    let gf_loan_refund_total = 0.00;
                    let gf_settlement_total = 0.00;
                
                    for(let i=0; i < gf_cont_data.length; i++)
                    {
                        

                        
                        //console.log(typeof(this.toMoney(gf_cont_data[i].gf_employer)));

                        let gf_employer = parseFloat(this.toMoney(gf_cont_data[i].gf_employer));
                        let gf_employee = parseFloat(this.toMoney(gf_cont_data[i].gf_employee));
                        let gf_profit = parseFloat(this.toMoney(gf_cont_data[i].gf_profit));
                        let gf_forfieture = parseFloat(this.toMoney(gf_cont_data[i].gf_forfieture));
                        let gf_loan_availed = parseFloat(this.toMoney(gf_cont_data[i].gf_loan_availed));
                        let gf_loan_refund = parseFloat(this.toMoney(gf_cont_data[i].gf_loan_refund));
                        let gf_settlement = parseFloat(this.toMoney(gf_cont_data[i].gf_settlement));
                        
                        

                        gf_employer_total += gf_employer;
                        gf_employee_total += gf_employee;
                        gf_profit_total += gf_profit;
                        gf_forfieture_total += gf_forfieture;
                        gf_loan_availed_total += gf_loan_availed;
                        gf_loan_refund_total += gf_loan_refund; 
                        gf_settlement_total += gf_settlement; 

                    }


                    this.curr_emp_monthly_gf_total.gf_employer = gf_employer_total + this.curr_emp_mgf_total.gf_employer;
                    this.curr_emp_monthly_gf_total.gf_employee = gf_employee_total + this.curr_emp_mgf_total.gf_employee;
                    this.curr_emp_monthly_gf_total.gf_profit = gf_profit_total;
                    this.curr_emp_monthly_gf_total.gf_forfieture = gf_forfieture_total;
                    this.curr_emp_monthly_gf_total.gf_loan_availed = gf_loan_availed_total;
                    this.curr_emp_monthly_gf_total.gf_loan_refund = gf_loan_refund_total;
                    this.curr_emp_monthly_gf_total.gf_settlement = gf_settlement_total;
                    
                }

            },
            getMigratedGfTotalContribution: function(mgf_cont_data)
            {
                let mgf_employer_total = 0.00;
                let mgf_employee_total = 0.00;

                if(mgf_cont_data.length>0)
                {
                    
                    
                        for(let i=0; i < mgf_cont_data.length; i++)
                        {
                            
                            let mgf_employer = parseFloat(this.toMoney(mgf_cont_data[i].employer_contribution));
                            let mgf_employee = parseFloat(this.toMoney(mgf_cont_data[i].employee_contribution));
                            
                            mgf_employer_total += mgf_employer;
                            mgf_employee_total += mgf_employee;
    
                        }
                    
                }
                this.curr_emp_mgf_total.gf_employer = mgf_employer_total;
                this.curr_emp_mgf_total.gf_employee = mgf_employee_total;
                

            },
            gfDetails: function(emp_id)
            {
            this.$bvModal.show('bv-modal-gf-details');
            this.gfoverlay = true;
            let currentObj = this;
            console.log(this.gf_type);
            
            
             axios.get(this.$api_url+'/gfdetails/header', {
							  params: {
                                  employee_id: emp_id
							  }
             }).then(function(response){
		       if(response.data.data){
                 this.empdata = response.data.data;
                 this.emp_gf_title = this.gf_types[this.gf_type].text + ' GF Contribution of '+this.empdata['name'];
                 this.emp_btn_title = this.empdata['name']+'\'s '+this.gf_types[this.gf_type].text + ' GF Report';
             
	           }
             }.bind(this)).catch(function (error){currentObj.serverError(error);});
            
            
            axios.get(this.$api_url+'/filter-gfcontribution', {
							  params: {
								  serach_type: 2,
                                  gf_type: this.gf_type,
								  year_from: this.year_from,
								  year_to: this.year_to,
                                  month_from: this.month_from,
                                  month_to: this.month_to,
                                  employee_id: emp_id
							  }
					  }).then(function(response){
					   this.gfoverlay = false;
				       if(response.data.data){
                         this.m_search_data = response.data.data;
			           }
                      }.bind(this)).catch(function (error){currentObj.gfoverlay = false; currentObj.serverError(error);});
           },
           formatMoney: function(amount)
            {
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                money = amount;
                else{
                if(money.indexOf(".")<0)
                money = money+".00";
                }
                return money;
            }, 
           toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return amount;
            },
           downloadFullGFReport: function(file_type,selected_emp=false)
			  {
				     
                     
                     if(selected_emp && this.selected.length<=0){
                        this.$bvToast.toast('Nothing selected!!', {title: 'Error!',variant: 'danger',solid: true});
                        return false;
                     }
                     
                     if(file_type=='pdf')
                     this.action_loader2 = true;
                     else
                     this.action_loader = true;
                     
                     axios.get(this.$api_url+'/downloadfullgfreport' , {
							  params: {
							      serach_type: 0,
                                  gf_type: this.gf_type,
								  year_from: this.year_from,
								  year_to: this.year_to,
                                  month_from: this.month_from,
                                  month_to: this.month_to,
                                  y_year_from: this.y_year_from,
                                  y_year_to: this.y_year_to,
                                  d_type: file_type,
                                  employee_ids: this.selected,
							  }
					  }).then(function(response){
					   
                      this.action_loader2 = false;
                      this.action_loader = false;
                      
					  if(response.data.file_name){
				      if(file_type=='pdf')
                      this.download_file(response.data.file_name,'GF Report  '+this.m_lists[parseInt(this.month_from)-1].text+' '+this.year_from+' To '+this.m_lists[parseInt(this.month_to)-1].text+' '+this.year_to+'.pdf');
                      else
                      this.download_file(response.data.file_name,'GF Report  '+this.m_lists[parseInt(this.month_from)-1].text+' '+this.year_from+' To '+this.m_lists[parseInt(this.month_to)-1].text+' '+this.year_to+'.xls');
                      }
                      else if(response.data.error){
                        this.$bvToast.toast(response.data.error, {title: 'Error!',variant: 'danger',solid: true});
                      }else{
                        this.$bvToast.toast('Unexpected server error!', {title: 'Error!',variant: 'danger',solid: true});
                      } 
				  }.bind(this));
	        },
          download_file(fileURL, fileName) {
             if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                save.download = fileName || filename;
        	       if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
        				document.location = save.href; 
        			}else{
        		        var evt = new MouseEvent('click', {
        		            'view': window,
        		            'bubbles': true,
        		            'cancelable': false
        		        });
        		        save.dispatchEvent(evt);
        		        (window.URL || window.webkitURL).revokeObjectURL(save.href);
        			}	
            }
            else if ( !! window.ActiveXObject && document.execCommand){
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
           },
        },
        created: function(){
            this.getAcl();  
            this.getGFReportHeaderInfo();
            this.getGFContributionsData();
            this.getCompanyGFData();
        },
        computed: 
        {
            
            selectAll: {
                get: function () {
                    return this.gf_data ? this.selected.length == this.gf_data.length : false;
                },
                set: function (value) {
                    var selected = [];
                    if (value) {
                        this.gf_data.forEach(function (user) {
                            selected.push(user.employee_id);
                        });
                    } 
                    this.selected = selected;
                }
            }
        }
    }
</script>
